(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("LearningItemEditUrlModalCtrl", ["$scope", "notify", "$window", "learningItemUrlLocalizationResource", "learningItemUrlLocalization", learningItemEditUrlModalCtrl]);
    function learningItemEditUrlModalCtrl($scope, notify, $window, learningItemUrlLocalizationResource, learningItemUrlLocalization) {
        var vm = this;
        vm.learningItemUrlLocalization = learningItemUrlLocalization;
        vm.updateLearningItemUrlLocalization = updateLearningItemUrlLocalization;
        vm.gotoLink = gotoLink;
        vm.selectDisplayMode = selectDisplayMode;
        vm.showErrors = false;
        initializeDisplayMode();
        vm.isShown = function (displayOptionMode) {
            console.log("IsShown Fired");
            return displayOptionMode === vm.learningItemUrlLocalization.displayOptionMode;
        };
        function initializeDisplayMode() {
            if (vm.learningItemUrlLocalization.url)
                vm.learningItemUrlLocalization.displayOptionMode = "url";
            else
                vm.learningItemUrlLocalization.displayOptionMode = "embedCode";
        }
        function selectDisplayMode(value) {
            vm.learningItemUrlLocalization.displayOptionMode = value;
        }
        function gotoLink() {
            if (vm.learningItemUrlLocalization.url) {
                checkIfValidUrl();
                $window.open(vm.learningItemUrlLocalization.url, "_blank");
            }
        }
        function checkIfValidUrl() {
            if (vm.learningItemUrlLocalization.url) {
                if (vm.learningItemUrlLocalization.url.indexOf("http://") === -1 && vm.learningItemUrlLocalization.url.indexOf("https://") === -1 && vm.learningItemUrlLocalization.url.indexOf("ftp") === -1) {
                    vm.learningItemUrlLocalization.url = "http://" + vm.learningItemUrlLocalization.url;
                }
            }
        }
        function updateLearningItemUrlLocalization(isValid) {
            if (isValid) {
                checkIfValidUrl();
                if (vm.learningItemUrlLocalization.id > 0) {
                    learningItemUrlLocalizationResource.update({
                        id: vm.learningItemUrlLocalization.id
                    }, vm.learningItemUrlLocalization, function (result) {
                        vm.learningItemUrlLocalization = result;
                        notify({
                            messageTemplate: "<span translate='learningItem.updatedSuccessMessage'></span>", classes: "alert-success"
                        });
                        $scope.$close(result);
                    }, function () {
                        notify({ messageTemplate: "<span translate='common.genericError'></span>", classes: "alert-danger" });
                    });
                }
                else {
                    learningItemUrlLocalizationResource.save(vm.learningItemUrlLocalization, function (result) {
                        vm.learningItemUrlLocalization = result;
                        notify({
                            messageTemplate: "<span translate='learningItem.updatedSuccessMessage'></span>", classes: "alert-success"
                        });
                        $scope.$close(result);
                    }, function () {
                        notify({ messageTemplate: "<span translate='common.genericError'></span>", classes: "alert-danger" });
                    });
                }
            }
            else {
                vm.showErrors = true;
            }
        }
    }
})();
